import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/home")({
  head: () =>
    pageHead("Your Daily Design", {
      canonicalPath: "/home",
      robots: "noindex, nofollow",
    }),
});
